export function getTypelist(field, lossCause) {
  const options = {};
  let tempOptions;
  if (field === 'applyThirdParty') {
    tempOptions = applyThirdPartyOptions;
  } else if (field === 'peopleInTpVehicle') {
    tempOptions = peopleInTpVehicleOptions;
  }

  tempOptions.forEach((option) => {
    options[option.value] = option.label;
  });

  if (lossCause === 'multi_vehicle' && field === 'applyThirdParty') {
    options.unconsciousInTheirVehicle = 'Unconscious in their vehicle';
  }

  return options;
}

export const peopleInTpVehicleOptions = [
  {
    label: 'One',
    value: 'one',
  },
  {
    label: 'Two',
    value: 'two',
  },
  {
    label: 'Three',
    value: 'three',
  },
  {
    label: 'Four or more',
    value: 'fourOrMore',
  },
];

export const applyThirdPartyOptions = [
  {
    label: 'Not injured',
    value: 'notInjured',
  },
  {
    label: 'Minor injury',
    value: 'minorInjury',
  },
  {
    label: 'Ambulance on scene',
    value: 'ambulanceOnScene',
  },
  {
    label: 'Airlifted from scene',
    value: 'airliftedFromScene',
  },
  {
    label: 'Loss of life',
    value: 'lossOfLife',
  },
  {
    label: "I don't know",
    value: 'iDontKnow',
  },
];

export const insurerArray = [
  {
    CO_CODE: '793',
    CO_NAME: 'ACE INA INSURANCE COMPANY' },
  {
    CO_CODE: '451',
    CO_NAME: 'ALBERTA MOTOR INSURANCE COMPANY' },
  {
    CO_CODE: 'A01',
    CO_NAME: 'ALGOMA MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '096',
    CO_NAME: 'ALLIANZ GLOBAL RISK US INSURANCE COMPANY' },
  {
    CO_CODE: '325',
    CO_NAME: 'ALLSTATE INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '755',
    CO_NAME: "ALPHA, COMPAGNIE D'ASSURANCES INC." },
  {
    CO_CODE: '341',
    CO_NAME: 'ALPINA INSURANCE COMPANY LIMITED' },
  {
    CO_CODE: '476',
    CO_NAME: 'AMERICAN ROAD INSURANCE COMPANY, THE' },
  {
    CO_CODE: '101',
    CO_NAME: 'ARCH INSURANCE COMPANY' },
  {
    CO_CODE: '725',
    CO_NAME: 'ATLANTIC INSURANCE COMPANY LIMITED' },
  {
    CO_CODE: '157',
    CO_NAME: 'AVIVA INSURANCE' },
  {
    CO_CODE: '073',
    CO_NAME: 'AXA CANADA' },
  {
    CO_CODE: '459',
    CO_NAME: 'AXA GENERAL INSURANCE' },
  {
    CO_CODE: 'A03',
    CO_NAME: "AYR FARMERS' MUTUAL INSURANCE COMPANY" },
  {
    CO_CODE: 'A04',
    CO_NAME: 'BAY OF QUINTE MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '077',
    CO_NAME: 'BELAIRDIRECT/NORDIC INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: 'A05',
    CO_NAME: 'BERTIE AND CLINTON MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A07',
    CO_NAME: 'BRANT MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '762',
    CO_NAME: 'C.A.A. INSURANCE COMPANY' },
  {
    CO_CODE: '746',
    CO_NAME: 'CABOT INSURANCE COMPANY LIMITED' },
  {
    CO_CODE: '339',
    CO_NAME: 'CANADIAN COMMERCE INSURANCE COMPANY , THE' },
  {
    CO_CODE: '062',
    CO_NAME: 'CANADIAN DIRECT INSURANCE INC' },
  {
    CO_CODE: '903',
    CO_NAME: 'CANADIAN GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '098',
    CO_NAME: "CANADIAN MILLERS' MUTUAL INSURANCE COMPANY" },
  {
    CO_CODE: '414',
    CO_NAME: 'CANADIAN PROVINCIAL INSURANCE COMPANY , THE' },
  {
    CO_CODE: '165',
    CO_NAME: 'CANASSURANCE GENERAL INSURANCE CO. INC' },
  {
    CO_CODE: '773',
    CO_NAME: "CAPITALE, COMPAGNIE D'ASSURANCE GENERALE" },
  {
    CO_CODE: 'A08',
    CO_NAME: 'CARADOC DELAWARE MUTUAL FIRE INSURANCE COMPANY' },
  {
    CO_CODE: 'A09',
    CO_NAME: 'CAYUGA MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '686',
    CO_NAME: 'CENTENNIAL INSURANCE COMPANY' },
  {
    CO_CODE: '562',
    CO_NAME: 'CERTAS DIRECT INSURANCE COMPANY' },
  {
    CO_CODE: '676',
    CO_NAME: 'CHARTIS INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '053',
    CO_NAME: 'CHIEFTAIN INSURANCE COMPANY' },
  {
    CO_CODE: '819',
    CO_NAME: 'CHUBB INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '810',
    CO_NAME: 'COACHMAN INSURANCE COMPANY' },
  {
    CO_CODE: '445',
    CO_NAME: 'CONTINENTAL INSURANCE COMPANY , THE' },
  {
    CO_CODE: '771',
    CO_NAME: "COOPERANTS, COMPAGNIE D'ASSURANCE GENERALE" },
  {
    CO_CODE: '361',
    CO_NAME: 'CO-OPERATORS GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '160',
    CO_NAME: 'CORNHILL INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '899',
    CO_NAME: 'COSECO INSURANCE COMPANY' },
  {
    CO_CODE: '497',
    CO_NAME: 'CUMIS GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '575',
    CO_NAME: 'DESJARDINS ASSURANCES GENERALES INC.' },
  {
    CO_CODE: '007',
    CO_NAME: 'DOMINION OF CANADA GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A12',
    CO_NAME: 'DUFFERIN MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A13',
    CO_NAME: 'DUMFRIES MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '027',
    CO_NAME: 'ECHELON GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '094',
    CO_NAME: 'ECONOMICAL MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '100',
    CO_NAME: 'ELECTRIC INSURANCE COMPANY' },
  {
    CO_CODE: '511',
    CO_NAME: 'ELITE INSURANCE COMPANY' },
  {
    CO_CODE: 'A18',
    CO_NAME: 'ERIE MUTUAL FIRE INSURANCE COMPANY' },
  {
    CO_CODE: '807',
    CO_NAME: "FARMERS' MUTUAL FIRE INSURANCE COMPANY" },
  {
    CO_CODE: '189',
    CO_NAME: 'FEDERAL INSURANCE COMPANY' },
  {
    CO_CODE: '008',
    CO_NAME: 'FEDERATED INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '171',
    CO_NAME: 'FEDERATED MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '365',
    CO_NAME: 'FEDERATION INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '532',
    CO_NAME: 'FIRE INSURANCE COMPANY OF CANADA , THE' },
  {
    CO_CODE: '435',
    CO_NAME: 'GAN CANADA GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '669',
    CO_NAME: 'GCAN INSURANCE COMPANY' },
  {
    CO_CODE: '873',
    CO_NAME: 'GENERAL ACCIDENT INDEMNITY COMPANY , THE' },
  {
    CO_CODE: 'A21',
    CO_NAME: 'GERMANIA MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '655',
    CO_NAME: 'GORE MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A23',
    CO_NAME: 'GRENVILLE MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '842',
    CO_NAME: "GROUPE ESTRIE-RICHELIEU, COMPAGNIE D'ASSURANCE" },
  {
    CO_CODE: '538',
    CO_NAME: 'GUARANTEE COMPANY OF NORTH AMERICA , THE' },
  {
    CO_CODE: 'A25',
    CO_NAME: 'HALWELL MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '069',
    CO_NAME: 'HARTFORD FIRE INSURANCE COMPANY' },
  {
    CO_CODE: 'A27',
    CO_NAME: 'HAY MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '085',
    CO_NAME: 'HOME INSURANCE COMAPNY' },
  {
    CO_CODE: 'A28',
    CO_NAME: 'HOWARD MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A29',
    CO_NAME: 'HOWICK MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A26',
    CO_NAME: 'HTM INSURANCE COMPANY' },
  {
    CO_CODE: '757',
    CO_NAME: "INDUSTRIELLE-ALLIANCE, COMPAGNIE D'ASSURANCE" },
  {
    CO_CODE: '211',
    CO_NAME: 'INSURANCE COMPANY OF PRINCE EDWARD ISLAND' },
  {
    CO_CODE: '523',
    CO_NAME: "INTACT COMPAGNIE D'ASSURANCE" },
  {
    CO_CODE: '167',
    CO_NAME: 'INTACT INSURANCE COMPANY' },
  {
    CO_CODE: '828',
    CO_NAME: 'JEVCO INSURANCE COMPANY' },
  {
    CO_CODE: '092',
    CO_NAME: 'KEMPER CANADA' },
  {
    CO_CODE: 'A30',
    CO_NAME: 'KENT AND ESSEX MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A33',
    CO_NAME: 'L & A MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '885',
    CO_NAME: 'LA PERSONNELLE, ASSURANCES GENERALES INCL' },
  {
    CO_CODE: 'A31',
    CO_NAME: 'LAMBTON MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '621',
    CO_NAME: 'LIBERTY MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '274',
    CO_NAME: "LLOYD'S UNDERWRITERS" },
  {
    CO_CODE: '554',
    CO_NAME: "L'UNION CANADIENNE, COMPAGNIE D'ASSURANCES" },
  {
    CO_CODE: '796',
    CO_NAME: "L'UNIQUE GENERAL INSURANCE" },
  {
    CO_CODE: 'A37',
    CO_NAME: 'MCKILLOP MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '729',
    CO_NAME: 'METRO GENERAL INSURANCE CORP. LTD.' },
  {
    CO_CODE: 'A54',
    CO_NAME: 'MIDDLESEX MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '064',
    CO_NAME: 'MILLENIUM INSURANCE CORPORATION' },
  {
    CO_CODE: '402',
    CO_NAME: 'MISSISQUOI INSURANCE COMPANY, THE' },
  {
    CO_CODE: '820',
    CO_NAME: 'MITSUI SUMITOMO INSURANCE COMPANY LIMITED' },
  {
    CO_CODE: '163',
    CO_NAME: 'MOTORS INSURANCE CORPORATION' },
  {
    CO_CODE: '009',
    CO_NAME: 'MUNICIPAL ELECTRIC ASSOCIATION RECIPROCAL INSURANCE' },
  {
    CO_CODE: '288',
    CO_NAME: 'NORDIC INSURANCE' },
  {
    CO_CODE: 'A38',
    CO_NAME: 'NORFOLK MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A39',
    CO_NAME: 'NORTH BLENHEIM MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A40',
    CO_NAME: 'NORTH KENT MUTUAL FIRE INSURANCE COMPANY' },
  {
    CO_CODE: '568',
    CO_NAME: 'NORTH WATERLOO MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '760',
    CO_NAME: 'NORTHBRIDGE COMMERCIAL INSURANCE CORPORATION' },
  {
    CO_CODE: '850',
    CO_NAME: 'NORTHBRIDGE GENERAL INSURANCE CORPORATION' },
  {
    CO_CODE: '161',
    CO_NAME: 'NORTHBRIDGE PERSONAL INSURANCE CORPORTATION' },
  {
    CO_CODE: '020',
    CO_NAME: 'NOVEX INSURANCE COMPANY' },
  {
    CO_CODE: '398',
    CO_NAME: 'OLD REPUBLIC INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '043',
    CO_NAME: "ONTARIO SCHOOL BOARDS' INSURANCE EXCHANGE" },
  {
    CO_CODE: '843',
    CO_NAME: 'OPTIMUM ASSURANCE AGRICOLE' },
  {
    CO_CODE: '816',
    CO_NAME: 'OPTIMUM INSURANCE COMPANY' },
  {
    CO_CODE: '116',
    CO_NAME: "OPTIMUM SOCIETE D'ASSURANCE INC" },
  {
    CO_CODE: '590',
    CO_NAME: 'OPTIMUM WEST INSURANCE COMPANY' },
  {
    CO_CODE: '417',
    CO_NAME: 'PAFCO INSURANCE COMPANY LTD' },
  {
    CO_CODE: '075',
    CO_NAME: 'PEACE HILLS GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A44',
    CO_NAME: 'PEEL MARYBOROUGH MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A43',
    CO_NAME: 'PEEL MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '059',
    CO_NAME: 'PEMBRIDGE INSURANCE COMPANY' },
  {
    CO_CODE: '269',
    CO_NAME: 'PEOPLEPLUS INSURANCE' },
  {
    CO_CODE: '766',
    CO_NAME: 'PERSONAL INSURANCE COMPANY OF CANADA, THE' },
  {
    CO_CODE: '428',
    CO_NAME: 'PERTH INSURANCE COMPANY' },
  {
    CO_CODE: '213',
    CO_NAME: 'PORTAGE LA PRAIRE MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A45',
    CO_NAME: 'PRESCOTT MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '896',
    CO_NAME: 'PRIMMUM INSURANCE COMPANY' },
  {
    CO_CODE: '835',
    CO_NAME: 'PROGRESSIVE CASUALTY INSURANCE COMPANY' },
  {
    CO_CODE: '855',
    CO_NAME: 'PROMUTUEL APALACHES, SMAG' },
  {
    CO_CODE: '858',
    CO_NAME: 'PROMUTUEL BAGOT, SMAG' },
  {
    CO_CODE: '846',
    CO_NAME: 'PROMUTUEL BEAUCE, SMAG' },
  {
    CO_CODE: '857',
    CO_NAME: 'PROMUTUEL BELLECHASSE, SMAG' },
  {
    CO_CODE: '870',
    CO_NAME: 'PROMUTUEL BOIS-FRANCS, SMAG' },
  {
    CO_CODE: '833',
    CO_NAME: 'PROMUTUEL CHARLEVOIX-MONTMORENCY, SMAG' },
  {
    CO_CODE: '890',
    CO_NAME: 'PROMUTUEL COATICOOK-SHERBROOKE, SMAG' },
  {
    CO_CODE: '834',
    CO_NAME: 'PROMUTUEL DES RIVERAINS, SMAG' },
  {
    CO_CODE: '894',
    CO_NAME: 'PROMUTUEL DEUX-MONTAGNES, SMAG' },
  {
    CO_CODE: '868',
    CO_NAME: 'PROMUTUEL DRUMMOND, SMAG' },
  {
    CO_CODE: '866',
    CO_NAME: 'PROMUTUEL DU LAC AU FJORD' },
  {
    CO_CODE: '891',
    CO_NAME: 'PROMUTUEL FRONTENAC, SMAG' },
  {
    CO_CODE: '826',
    CO_NAME: 'PROMUTUEL GASPESIE LES ILES, SMAG' },
  {
    CO_CODE: '822',
    CO_NAME: 'PROMUTUEL HAUT ST-LAURENT, SMAG' },
  {
    CO_CODE: '844',
    CO_NAME: 'PROMUTUEL KAMOURASKA, SMAG' },
  {
    CO_CODE: '892',
    CO_NAME: 'PROMUTUEL LA VALLEE, SMAG' },
  {
    CO_CODE: '893',
    CO_NAME: "PROMUTUEL L'ABITIBIENNE, SMAG" },
  {
    CO_CODE: '821',
    CO_NAME: 'PROMUTUEL LANAUDIERE, SMAG' },
  {
    CO_CODE: '875',
    CO_NAME: 'PROMUTUEL LES PRAIRIES, SMAG' },
  {
    CO_CODE: '847',
    CO_NAME: 'PROMUTUEL LEVISIENNE-ORLEANS, SMAG' },
  {
    CO_CODE: '881',
    CO_NAME: "PROMUTUEL L'OUTAOUAIS, SMAG" },
  {
    CO_CODE: '883',
    CO_NAME: 'PROMUTUEL MAURICIENNE, SMAG' },
  {
    CO_CODE: '887',
    CO_NAME: 'PROMUTUEL MONTMAGNY, SMAG' },
  {
    CO_CODE: '859',
    CO_NAME: 'PROMUTUEL PORTNEUF-CHAMPLAIN, SMAG' },
  {
    CO_CODE: '830',
    CO_NAME: 'PROMUTUEL REASSURANCE, SMAG' },
  {
    CO_CODE: '865',
    CO_NAME: 'PROMUTUEL RIVIERE-DU-LOUP, SMAG' },
  {
    CO_CODE: '860',
    CO_NAME: 'PROMUTUEL SAGUENAY, SMAG' },
  {
    CO_CODE: '882',
    CO_NAME: 'PROMUTUEL SOULANGES, SMAG' },
  {
    CO_CODE: '862',
    CO_NAME: 'PROMUTUEL VALMONT, SMAG' },
  {
    CO_CODE: '836',
    CO_NAME: 'PROMUTUEL VAUDREUIL, SMAG' },
  {
    CO_CODE: '876',
    CO_NAME: 'PROMUTUEL VERCHERES, SMAG' },
  {
    CO_CODE: '014',
    CO_NAME: 'PROTECTIVE INSURANCE COMPANY' },
  {
    CO_CODE: '578',
    CO_NAME: 'QUEBEC ASSURANCE COMPANY' },
  {
    CO_CODE: '079',
    CO_NAME: 'RBC GENERAL INSURANCE COMPANY (ALBERTA)' },
  {
    CO_CODE: '031',
    CO_NAME: 'RBC GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '040',
    CO_NAME: 'ROYAL & SUN ALLIANCE INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '086',
    CO_NAME: 'S & Y INSURANCE COMPANY' },
  {
    CO_CODE: '675',
    CO_NAME: 'SAFECO INSURANCE COMPANY OF AMERICA' },
  {
    CO_CODE: '260',
    CO_NAME: 'SASKATCHEWAN MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '016',
    CO_NAME: 'SCOTIA GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '446',
    CO_NAME: 'SCOTTISH & YORK INSURANCE COMPANY LIMITED' },
  {
    CO_CODE: '614',
    CO_NAME: "SECURITE NATIONALE, COMPAGNIE D'ASSURANCE" },
  {
    CO_CODE: '135',
    CO_NAME: 'SECURITY INSURANCE COMPANY OF HARTFORD' },
  {
    CO_CODE: '357',
    CO_NAME: "SELECTA NATIONAL D'ASSURANCES INC." },
  {
    CO_CODE: '756',
    CO_NAME: 'SENTRY INSURANCE, A MUTUAL COMPANY' },
  {
    CO_CODE: '313',
    CO_NAME: 'SGI CANADA INSURANCE SERVICES LIMITED' },
  {
    CO_CODE: '124',
    CO_NAME: 'SONNET INSURANCE COMPANY' },
  {
    CO_CODE: 'A46',
    CO_NAME: 'SOUTH EASTHOPE MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '370',
    CO_NAME: 'SOVEREIGN GENERAL INSURANCE COMPANY, THE' },
  {
    CO_CODE: '898',
    CO_NAME: "SSQ, SOCIETE D'ASSURANCES GENERALES INC." },
  {
    CO_CODE: '113',
    CO_NAME: 'ST. PAUL FIRE AND MARINE INSURANCE COMPANY, THE' },
  {
    CO_CODE: '685',
    CO_NAME: 'STATE FARM FIRE & CASUALTY COMPANY' },
  {
    CO_CODE: '645',
    CO_NAME: 'STATE FARM MUTUAL AUTOMOBILE INSURANCE COMPANY' },
  {
    CO_CODE: '455',
    CO_NAME: "ST-MAURICE, COMPAGNIE D'ASSURANCE" },
  {
    CO_CODE: '034',
    CO_NAME: 'TD GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: '683',
    CO_NAME: 'TIG INSURANCE COMPANY' },
  {
    CO_CODE: '588',
    CO_NAME: 'TOKIO MARINE & NICHIDO FIRE INSURANCE COMPANY' },
  {
    CO_CODE: 'A55',
    CO_NAME: 'TOWN AND COUNTRY MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A48',
    CO_NAME: "TOWNSEND FARMERS' MUTUAL FIRE INSURANCE COMPANY" },
  {
    CO_CODE: '346',
    CO_NAME: 'TRADERS GENERAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A56',
    CO_NAME: 'TRADITION MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '824',
    CO_NAME: 'TRAFALGAR INSURANCE COMPANY OF CANADA' },
  {
    CO_CODE: '186',
    CO_NAME: 'TRAVELERS GUARANTEE COMPANY OF CANADA' },
  {
    CO_CODE: 'A57',
    CO_NAME: 'TRILLIUM MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '099',
    CO_NAME: 'TRISURA GUARANTEE INSURANCE COMPANY' },
  {
    CO_CODE: '731',
    CO_NAME: 'UNIFUND ASSURANCE COMPANY' },
  {
    CO_CODE: '299',
    CO_NAME: "UNION CANADIENNE, COMPAGNIE D'ASSURANCES" },
  {
    CO_CODE: '543',
    CO_NAME: 'UNITED GENERAL INSURANCE CORPORATION' },
  {
    CO_CODE: '206',
    CO_NAME: 'UNITED STATES FIRE INSURANCE COMPANY' },
  {
    CO_CODE: '999',
    CO_NAME: 'UNKNOWN' },
  {
    CO_CODE: 'A49',
    CO_NAME: 'USBORNE AND HIBBERT MUTUAL FIRE INSURANCE COMPANY' },
  {
    CO_CODE: '673',
    CO_NAME: 'UTICA MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A50',
    CO_NAME: 'WABISA MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '633',
    CO_NAME: 'WATERLOO INSURANCE COMPANY' },
  {
    CO_CODE: '207',
    CO_NAME: 'WAWANESA MUTUAL INSURANCE COMPANY, THE' },
  {
    CO_CODE: 'A14',
    CO_NAME: 'WEST ELGIN MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A52',
    CO_NAME: 'WEST WAWANOSH MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '032',
    CO_NAME: 'WESTERN ASSURANCE COMPANY' },
  {
    CO_CODE: '849',
    CO_NAME: 'WESTERN GENERAL MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: 'A51',
    CO_NAME: 'WESTMINSTER MUTUAL INSURANCE COMPANY' },
  {
    CO_CODE: '081',
    CO_NAME: 'XL INSURANCE COMPANY LIMITED' },
  {
    CO_CODE: 'A53',
    CO_NAME: 'YARMOUTH MUTUAL FIRE INSURANCE COMPANY' },
  {
    CO_CODE: '303',
    CO_NAME: 'YORK FIRE AND CASUALTY INSURANCE COMPANY' },
  {
    CO_CODE: '021',
    CO_NAME: 'ZENITH INSURANCE COMPANY' },
  {
    CO_CODE: '119',
    CO_NAME: 'ZURICH INSURANCE COMPANY LTD.' },
];

export const issuingProvince = [
  {
    selectedLabel: 'Alberta',
    label: 'Alberta',
    value: 'AB',
  },
  {
    selectedLabel: 'British Columbia',
    label: 'British Columbia',
    value: 'BC',
  },
  {
    selectedLabel: 'Manitoba',
    label: 'Manitoba',
    value: 'MB',
  },
  {
    selectedLabel: 'New Brunswick',
    label: 'New Brunswick',
    value: 'NB',
  },
  {
    selectedLabel: 'Newfoundland and Labrador',
    label: 'Newfoundland and Labrador',
    value: 'NL',
  },
  {
    selectedLabel: 'Northwest Territories',
    label: 'Northwest Territories',
    value: 'NT',
  },
  {
    selectedLabel: 'Nova Scotia',
    label: 'Nova Scotia',
    value: 'NS',
  },
  {
    selectedLabel: 'Nunavut',
    label: 'Nunavut',
    value: 'NU',
  },
  {
    selectedLabel: 'Ontario',
    label: 'Ontario',
    value: 'ON',
  },
  {
    selectedLabel: 'Prince Edward Island',
    label: 'Prince Edward Island',
    value: 'PE',
  },
  {
    selectedLabel: 'Quebec',
    label: 'Quebec',
    value: 'QC',
  },
  {
    selectedLabel: 'Saskatchewan',
    label: 'Saskatchewan',
    value: 'SK',
  },
  {
    selectedLabel: 'Yukon',
    label: 'Yukon',
    value: 'YT',
  },
  {
    selectedLabel: 'International',
    label: 'International',
    value: 'OTHER',
  },
];
